module.exports = __webpack_public_path__ + "static/img/egg_b_02.6635746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_02.png
// module id = VYxd
// module chunks = 1